import React from 'react';
const milestones = [{
  week: 'Woche 1–2 · Eingewöhnung',
  text: 'Halbe Dosis über Lenies Trockenfutter. Sie fraß es anstandslos. Keine Veränderungen sichtbar – aber auch keinerlei Probleme. Ein gutes Zeichen.'
}, {
  week: 'Woche 3–4 · Erste Zeichen',
  text: 'Lenies Stuhlgang wurde merklich fester und regelmäßiger. Ich bemerkte, dass sie sich abends etwas weniger kratzte. Vielleicht Zufall, vielleicht nicht.'
}, {
  week: 'Woche 5–6 · Spürbare Verbesserung',
  text: 'Das Kratzen an den Achseln wurde deutlich seltener. Lenies Pfoten sahen ruhiger aus. Ich fing an, wirklich daran zu glauben.'
}, {
  week: 'Nach 2 Monaten · Der Unterschied',
  text: 'Die ruhigsten Wochen seit zwei Jahren – mitten in der Pollensaison. Kein Scheuern, keine entzündeten Stellen. Lenies Fell begann, wieder Glanz zu bekommen.'
}];
export function Timeline() {
  return <div className="border-l-[2px] border-amber-lt pl-6 my-[2em] flex flex-col gap-[22px]" data-id="element-87">
      {milestones.map((milestone, index) => <div key={index} data-id="element-88">
          <div className="font-sans text-[0.68rem] font-bold tracking-[0.13em] uppercase text-amber mb-1" data-id="element-89">
            {milestone.week}
          </div>
          <p className="text-[0.93rem] text-text-mid mb-0 leading-[1.85]" data-id="element-90">
            {milestone.text}
          </p>
        </div>)}
    </div>;
}